import View from 'views/base/view';
import CompatibilityTemplate from './templates/compatibility';

const CompatibilityView = View.extend({
  autoRender: true,
  className: 'compatibility',
  autoAttach: true,
  template: CompatibilityTemplate,
  initialize: function (options) {
    View.prototype.initialize.apply(this, arguments);
  },
});

export default CompatibilityView;
